import React from 'react';
import Svg from '../Svg';

import { IconProps } from '../icon';

export const External16 = ({
  accessibilityLabel,
  contrast,
  className,
}: IconProps) => (
  <Svg
    accessibilityLabel={accessibilityLabel}
    size={16}
    contrast={contrast}
    className={className}
  >
    <path
      d='M2.75 2.75H7V1.25H2.5C1.80964 1.25 1.25 1.80964 1.25 2.5V13.5C1.25 14.1904 1.80964 14.75 2.5 14.75H13.5C14.1904 14.75 14.75 14.1904 14.75 13.5V9H13.25V13.25H2.75V2.75Z'
      fill='currentColor'
    />
    <path
      d='M13.25 3.81071L7.03039 10.0303L5.96973 8.96967L12.1894 2.75H10V1.25H14.75V6H13.25V3.81071Z'
      fill='currentColor'
    />
  </Svg>
);

External16.displayName = 'External16';
export default External16;
